import { Box, Typography } from '@coolblue-development/becky';
import { EmailContactData } from '../../../../../models/EmailContact';
import CopyContactIdButton from '../CopyContactIdButton/CopyContactIdButton';
import { formatReceivedAt } from '../../../../../utils/emailContactHelpers';
import { Paperclip } from '@coolblue-development/icons';

interface EmailHeaderPreviewProps {
  data: EmailContactData;
}

const PREVIEW_MAX_LENGTH = 160;

const truncatePreview = (text: string): string =>
  text.length > PREVIEW_MAX_LENGTH ? `${text.slice(0, PREVIEW_MAX_LENGTH)}...` : text;

const EmailHeaderPreview = ({ data }: EmailHeaderPreviewProps): JSX.Element => {
  return (
    <div data-testid="email-header-preview">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        {data.customerName && (
          <Typography variant="h6" data-testid="email-customer-name">
            {data.customerName}
          </Typography>
        )}
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center' }}>
          {data.hasAttachments && <Paperclip color="#868A90" />}
          <CopyContactIdButton contactId={data.contactId} />
          {data.receivedAt && (
            <Typography variant="subtitle2" data-testid="email-received-at">
              {formatReceivedAt(data.receivedAt)}
            </Typography>
          )}
        </Box>
      </Box>
      {data.bodyPreview && (
        <Typography variant="body1" color="textSecondary">
          {truncatePreview(data.bodyPreview)}
        </Typography>
      )}
    </div>
  );
};

export default EmailHeaderPreview;
